import { useAuth } from '@/hooks/use-auth';
import {
  memberDisplay,
  type MemberDisplay,
  type MemberDisplayInput,
} from '@/utils/member-display';

/**
 * Wraps `memberDisplay` with the currently authenticated viewer so callers
 * never have to thread auth context manually. See `member-display.ts` for
 * the privacy contract this hook enforces.
 */
export function useMemberDisplay(member: MemberDisplayInput): MemberDisplay {
  const { user } = useAuth();
  return memberDisplay(member, {
    viewerId: user?.id ?? '',
    viewerRole: user?.role ?? 'collector',
  });
}
